module.exports = __webpack_public_path__ + "img/saudi-brand-logo.0b817c3d.svg";